module.exports = __webpack_public_path__ + "static/media/logo-white.8f9931a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-white.svg
// module id = 238
// module chunks = 0